/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddProductReviewDto } from '../../models/add-product-review-dto';
import { ProductReviewDto } from '../../models/product-review-dto';

export interface CreateProductReview$Params {
      body: AddProductReviewDto
}

export function createProductReview(http: HttpClient, rootUrl: string, params: CreateProductReview$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductReviewDto>> {
  const rb = new RequestBuilder(rootUrl, createProductReview.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProductReviewDto>;
    })
  );
}

createProductReview.PATH = '/api/v1/product-reviews';
